// src/contexts/CountryContext.jsx
// 국가 선택 → 언어/CSS 변수 동적 교체.
// CLAUDE.md "6. 국가/다국어/테마" 의 단일 진실 원천.

import { createContext, useContext, useEffect, useState } from 'react';
import i18n from '../i18n';

export const COUNTRY_CONFIG = {
  KR: { lang: 'ko', primary: '#F59E0B', bg: '#FFFBEB', flag: '🇰🇷', name: '한국' },
  US: { lang: 'en', primary: '#1A56DB', bg: '#EFF6FF', flag: '🇺🇸', name: 'USA' },
  JP: { lang: 'ja', primary: '#10B981', bg: '#ECFDF5', flag: '🇯🇵', name: '日本' },
};

const STORAGE_KEY = 'citizencast.country';
const DEFAULT_COUNTRY = 'KR';

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const [country, setCountry] = useState(() => {
    const saved = typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY);
    return saved && COUNTRY_CONFIG[saved] ? saved : DEFAULT_COUNTRY;
  });

  // country 변경 시 부수효과: 언어 + CSS 변수
  useEffect(() => {
    const cfg = COUNTRY_CONFIG[country];
    i18n.changeLanguage(cfg.lang);
    document.documentElement.style.setProperty('--color-primary', cfg.primary);
    document.documentElement.style.setProperty('--color-bg', cfg.bg);
    document.documentElement.lang = cfg.lang;
    localStorage.setItem(STORAGE_KEY, country);
  }, [country]);

  function changeCountry(code) {
    if (!COUNTRY_CONFIG[code]) return;
    setCountry(code);
  }

  return (
    <CountryContext.Provider
      value={{
        country,
        config: COUNTRY_CONFIG[country],
        changeCountry,
        allCountries: COUNTRY_CONFIG,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const ctx = useContext(CountryContext);
  if (!ctx) throw new Error('useCountry must be used within CountryProvider');
  return ctx;
}
